// extracted by mini-css-extract-plugin
export var button = "styles-module__button___g5W3q";